import { Button, ButtonGroup, SimpleGrid, Stack } from '@chakra-ui/react';
import { useTranslation } from 'next-i18next';
import Image from 'next/image';
import { HiArrowDownTray } from 'react-icons/hi2';
import useDownloader from 'react-use-downloader';
import { fileNames } from './utils/constants';
import BaseButton from '@/components/BaseButton';
import { FaDownload } from 'react-icons/fa6';
import { colors } from '@/styles/theme/colors';
import { H2 } from '@/components/Headings';
import { TextDefault } from '@/components/Texts';

const Downloads = () => {
  const { t } = useTranslation('main');
  const { download } = useDownloader();

  return (
    <Stack
      align={'center'}
      spacing={8}
      py={8}
      px={{ base: 8, lg: 0 }}
      color={colors.diment.darkBlue}
    >
      <Stack textAlign={'center'}>
        <H2>{t('assets.downloads.heading')}</H2>
        <TextDefault maxW={'2xl'}>
          {' '}
          {t('assets.downloads.description')}
        </TextDefault>
      </Stack>

      <SimpleGrid w={'full'} gap={8} columns={{ base: 1, sm: 2, lg: 3, xl: 6 }}>
        {fileNames.map((fileName) => (
          <Stack
            w={'full'}
            h={'auto'}
            role='group'
            borderRadius={4}
            minH={48}
            justify={'center'}
            align={'center'}
            position={'relative'}
            key={fileName}
            bgColor={colors.diment.lightBlueTransparent}
            _hover={{ bgColor: colors.diment.lighterBlueTransparent }}
          >
            <Image
              priority
              src={`/images/assets/png-files/${fileName}.png`}
              width={100}
              height={100}
              alt='downloadable asset'
              style={{ objectFit: 'contain' }}
            />
            <ButtonGroup
              position={'absolute'}
              bottom={2}
              left={'50%'}
              transform={'translateX(-50%)'}
            >
              <Button
                onClick={() =>
                  download(
                    `/images/assets/svg-files/${fileName}.svg`,
                    `${fileName}.svg`,
                  )
                }
                _groupHover={{ opacity: 1 }}
                opacity={0}
                transitionDuration={'0.5s'}
                size={'sm'}
                borderRadius={2}
                colorScheme={'green'}
                leftIcon={<HiArrowDownTray />}
              >
                .SVG
              </Button>
              <Button
                onClick={() =>
                  download(
                    `/images/assets/png-files/${fileName}.png`,
                    `${fileName}.png`,
                  )
                }
                _groupHover={{ opacity: 1 }}
                opacity={0}
                transitionDuration={'0.5s'}
                size={'sm'}
                borderRadius={2}
                bgColor={'white'}
                colorScheme={'gray'}
                leftIcon={<HiArrowDownTray />}
              >
                .PNG
              </Button>
            </ButtonGroup>
          </Stack>
        ))}
      </SimpleGrid>
      <BaseButton
        leftIcon={<FaDownload />}
        onClick={() => {
          download(`/images/assets/all-files.zip`, `all-files.zip`);
        }}
        bg={colors.diment.darkBlue}
      >
        Download All
      </BaseButton>
    </Stack>
  );
};

export default Downloads;
